module.exports = __webpack_public_path__ + "img/Fit@2x.1ff95fb3.png";